$(document).ready(function () {
    $('.disclaimer-bar .disclaimer-bar__opt-out').click(function () {
        $('.disclaimer-bar').addClass('disclaimer-bar--hide');
    });
    $('.disclaimer-bar .disclaimer-bar__opt-in').click(function () {
        var el = $(this);
        var url = el.data('optInUrl');
        if (url) {
            $.ajax({url: url, method: 'POST'});
        }
        $('.disclaimer-bar').addClass('disclaimer-bar--hide');
    });
});